/**
 * @FileDescription: 流程-流程发送
 * @Author: 乔锋
 * @Date: 2021-07-14
 * @LastEditors: 乔锋
 * @LastEditTime: 2021-08-16
 */
import axios from '@/api/utils/axios';
import BaseApi from '@/api/utils/baseApi.js';

const WorkflowApi = {
	/**
	 * @description: 基础地址
	 */
	baseUrl: function() {
		return '/longstron/workflow/workflow';
	},
	/**
	 * @description: 当前数据是否能够发起流程
	 * @param {String} baseUrl 服务基础路径
	 * @param {String} entityId  数据实体id
	 */
	capable: function(baseUrl, entityId) {
		return axios.get(baseUrl + "/workflow/capable/" + entityId);
	},
	/**
	 * @description: 发送流程
	 * @param {String} baseUrl 服务基础路径
	 * @param {String} entityId  数据实体id
	 * @param {Object} workflow  流程信息
	 * @param {Object} params  params参数
	 */
	send: function(baseUrl, entityId, workflow, params) {
		return axios.put(baseUrl + "/workflow/send/" + entityId, workflow, {
			params: params
		});
	},
	/**
	 * @description: 保存并且发送
	 * @param {String} baseUrl 服务基础路径
	 * @param {String} entityId  数据实体id
	 * @param {Object} workflow  流程信息
	 * @param {Object} params  params参数
	 */
	saveAndSend: function(baseUrl, entity, workflow, params) {
		return axios.put(baseUrl + "/workflow/save/send", {command: entity, workflow: workflow}, {
			params: params
		});
	},
	/**
	 * @description: 根据分类查询流程查询审批收到列表
	 * @param {Object} limit 搜索分页等限制参数
	 */
	limit: function(limit) {
		return axios.post(this.baseUrl() + '/mytask/queryLimit', limit);
	},
	/**
	 * @description: 根据分类查询流程查询审批发送列表
	 * @param {String} type 流程分类
	 * @param {Object} limit 搜索分页等限制参数
	 */
	querySendByType: function(type, limit) {
		return axios.post(this.baseUrl() + '/mytask/getby/' + type + '/send', limit);
	},
	/**
	 * @description 根据流程id获取流程审批记录
	 * @param {String} workflowId 流程id
	 */
	getHistories: function(workflowId) {
		return axios.get(this.baseUrl() + '/mytask/get/histories/' + workflowId);
	},
	
	/**
	 * @description 根据流程id获取流程审批记录
	 * @param {String} workflowId 流程id
	 */
	getPrint: function(objectId) {
		return axios.get(this.baseUrl() + '/mytask/get/print/histories/' + objectId);
	},
	
	/**
	 * @description 根据单据id获取流程审批记录
	 * @param {String} entityId 单据id
	 */
	getHistoriesByDataId: function(entityId) {
		return axios.get(this.baseUrl() + '/mytask/get/histories/all', {
			params: {
				dataId: entityId
			}
		});
	},
	/**
	 * @description 查询下一审批节点
	 * @param {String} workflowListId 流程节点id
	 */
	next: function(workflowListId) {
		return axios.get(this.baseUrl() + '/task/next/' + workflowListId);
	},
	/**
	 * @description 流程审批操作
	 * @param {Object} model 执行参数
	 */
	audit: function(model) {
		return axios.put(this.baseUrl() + '/mytask/complete/task', model);
	},
	/**
	 * @description 根据流程节点id查询可驳回至的节点清单
	 * @param {String} workflowListId 流程节点id
	 */
	getBackActivity: function(workflowListId) {
		return axios.get(this.baseUrl() + '/mytask/get/back/activity/' + workflowListId);
	},
	/**
	 * @description 根据类型查询审批数量值
	 */
	getTodoListCount: function(params) {
		return axios.get(this.baseUrl() + '/mytask/get/receiveCount', { params });
	},
	/**
	 * @description 根据类型查询审批数量值
	 * @param {String} type 类型
	 */
	batchCompleteTask: function(entity) {
		return axios.put(this.baseUrl() + '/mytask/batch/complete/task', entity);
	},
};

export default Object.assign(WorkflowApi, BaseApi);
